<!-- <cosmos-image [url]="'https://cosmos-dev-v2.imgix.net//7622d9e9-f457-4ebe-8089-cd93a1d32ef2'">
</cosmos-image> -->
<button
    (click)="isOpen = !isOpen"
    class="cosmos-select__selected"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin">{{ value }}</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
>
  <ul class="cosmos-select__list">
    <li 
      *ngFor="let value of values; index as i;"
      class="cosmos-select__item"
      (click)="select(i); isOpen = false"
    >{{i}}/{{value}}</li>
  </ul>
</ng-template>